<template>
  <Box>
    <BoxHead icon="fas fa-id-card">
      Personal Information
    </BoxHead>

    <BoxLoader v-if="loading" />

    <EmptySection
      v-else-if="isEmpty"
      :badges="['Personal Information', 'Relationships', 'Tax']"
      :entity-external-id="entityExternalId"
    />

    <template v-else>
      <DetailsList>
        <DetailPair
          v-if="personalInfo?.legalName"
          label="Legal Name"
          :value="personalInfo.legalName"
        />

        <DetailPair
          v-if="personalInfo?.preferredName"
          label="Preferred Name"
          :value="personalInfo.preferredName"
        />

        <DetailPair
          v-if="personalInfo?.dob"
          label="Date of Birth"
          :value="personalInfo.dob"
        />

        <DetailPair
          v-if="personalInfo?.maritalStatus"
          label="Marital Status"
          :value="personalInfo.maritalStatus"
        />

        <DetailPair
          v-if="personalInfo?.age"
          label="Age"
          :value="personalInfo.age"
        />

        <DetailPair
          v-if="personalInfo?.mobilePhone"
          label="Mobile Phone"
          :value="personalInfo.mobilePhone"
        />

        <DetailPair
          v-if="personalInfo?.email"
          label="Email Address"
          :value="personalInfo.email"
        />

        <DetailPair
          v-if="personalInfo?.occupation"
          label="Occupation"
          :value="personalInfo.occupation"
        />

        <DetailPair
          v-if="personalInfo?.employer"
          label="Occupation"
          :value="personalInfo.employer"
        />
      </DetailsList>

      <DetailsList v-if="taxInfo">
        <DetailsTitle>
          Tax Information
        </DetailsTitle>

        <DetailPair
          v-if="taxInfo.tax_bracket"
          label="Tax Bracket"
          :value="taxInfo.tax_bracket"
        />

        <DetailPair
          v-if="taxInfo.adjusted_gross_income"
          label="Adjusted Gross Income"
          :value="taxInfo.adjusted_gross_income"
        />
      </DetailsList>

      <DetailsList v-if="personalInfo?.spouse">
        <DetailsTitle>
          Spouse
        </DetailsTitle>

        <DetailPair
          v-if="personalInfo?.spouse.name"
          label="Name"
          :value="personalInfo.spouse.name"
        />

        <DetailPair
          v-if="personalInfo?.spouse.age"
          label="Age"
          :value="personalInfo.spouse.age"
        />

        <DetailPair
          v-if="personalInfo?.spouse.birthdate"
          label="Birth Date"
          :value="personalInfo.spouse.birthdate"
        />

        <DetailPair
          v-if="personalInfo?.spouse.notes"
          label="Birth Date"
          :value="personalInfo.spouse.notes"
        />
      </DetailsList>

      <DetailsList v-if="personalInfo?.children && personalInfo.children.length > 0">
        <DetailsTitle>
          Children
        </DetailsTitle>

        <template
          v-for="(child) in personalInfo.children"
        >
          <DetailPair
            v-if="child.name"
            :key="child.name"
            label="Name"
            :value="child.name"
          />

          <DetailPair
            v-if="child.age"
            :key="child.age"
            label="Age"
            :value="child.age"
          />

          <DetailPair
            v-if="child.birthdate"
            :key="child.birthdate"
            label="Birth Date"
            :value="child.birthdate"
          />

          <DetailPair
            v-if="child.notes"
            :key="child.notes"
            label="Birth Date"
            :value="personalInfo.spouse.notes"
          />
        </template>
      </DetailsList>
    </template>
  </Box>
</template>

<script setup>
import { computed } from 'vue';
import { Box, BoxHead, DetailPair, DetailsList, DetailsTitle, BoxLoader } from '@stakeui';
import EmptySection from './EmptySection.vue';
import { isEmptyValue } from '@frontend/shared/Util.js';

const props = defineProps({
  client: {
    type: Object,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  entityExternalId: {
    type: String,
    required: true,
  },
});

const personalInfo = computed(() => props.client?.personalInfo);
const taxInfo = computed(() => props.client?.tax_info);
const isEmpty = computed(() => {
  return isEmptyValue(personalInfo.value || {}) && isEmptyValue(taxInfo.value || {});
});
</script>
